import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['project']),
  },
  methods: {
    fireTrackEvent (action, label, value) {
      value = value || null
      const hitEvent = {
        'event':         'allgemeinesEvent',
        'eventCategory': 'Registrierung',
        'eventAction':   action,
        'eventLabel':    label,
        'eventValue':    value
      };

      if(this.project) hitEvent['project'] = this.project

      this.$dataLayer.push(hitEvent);
    }
  }
}
